import type { JSX } from 'react';

type XTwitterIconProps = {
  className?: string;
};

const XTwitterIcon = (props: XTwitterIconProps): JSX.Element => {
  const { className } = props;
  return (
    <svg
      className={className || ''}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width="256"
      height="256"
      viewBox="0 0 256 256"
    >
      <g fill="#000" strokeMiterlimit="10" strokeWidth="0">
        <path d="m71.347 66.065 92.45 123.583h20.934L92.282 66.065z"></path>
        <path d="M127.857 1.407c-69.837 0-126.45 56.613-126.45 126.45s56.613 126.45 126.45 126.45 126.45-56.613 126.45-126.45-56.613-126.45-126.45-126.45m31 198.116-42.089-56.276-52.091 56.276h-13.39l59.499-64.276L51.66 56.19h45.57l38.76 51.828 47.973-51.828h13.39l-55.38 59.83 62.452 83.503z"></path>
      </g>
    </svg>
  );
};
export default XTwitterIcon;
